export const LIST_OF_PARTICIPATION_REQUEST = 'LIST_OF_PARTICIPATION_REQUEST';
export const LIST_OF_PARTICIPATION_REQUEST_SUCCESS =
	'LIST_OF_PARTICIPATION_REQUEST_SUCCESS';
export const LIST_OF_PARTICIPATION_REQUEST_FAILURE =
	'LIST_OF_PARTICIPATION_REQUEST_FAILURE';
export const CLEAR_LIST_OF_PARTICIPATION_PARAMS =
	'CLEAR_LIST_OF_PARTICIPATION_PARAMS';

export const LIST_OF_PARTICIPATION_DNI_REQUEST =
	'LIST_OF_PARTICIPATION_DNI_REQUEST';
export const LIST_OF_PARTICIPATION_DNI_REQUEST_SUCCESS =
	'LIST_OF_PARTICIPATION_DNI_REQUEST_SUCCESS';
export const LIST_OF_PARTICIPATION_DNI_REQUEST_FAILURE =
	'LIST_OF_PARTICIPATION_DNI_REQUEST_FAILURE';
export const CLEAR_LIST_OF_PARTICIPATION_DNI_PARAMS =
	'CLEAR_LIST_OF_PARTICIPATION_DNI_PARAMS';

export const POST_PARTICIPATION_REQUEST = 'POST_PARTICIPATION_REQUEST';
export const POST_PARTICIPATION_REQUEST_SUCCESS =
	'POST_PARTICIPATION_REQUEST_SUCCESS';
export const POST_PARTICIPATION_REQUEST_FAILURE =
	'POST_PARTICIPATION_REQUEST_FAILURE';

export const POST_STORE_PARTICIPATION_OFFLINE =
	'POST_STORE_PARTICIPATION_OFFLINE';
export const GET_STORE_PARTICIPATION_OFFLINE =
	'GET_STORE_PARTICIPATION_OFFLINE';
export const CLEAR_POST_STORE_PARTICIPATION_OFFLINE =
	'CLEAR_POST_STORE_PARTICIPATION_OFFLINE';

export const POST_STORE_PARTICIPATION_OFFLINE_DNI =
	'POST_STORE_PARTICIPATION_OFFLINE_DNI';
export const CLEAR_POST_STORE_PARTICIPATION_OFFLINE_DNI =
	'CLEAR_POST_STORE_PARTICIPATION_OFFLINE_DNI';
